import { useEffect, useState } from "react";
import { get, has } from "lodash";
import tvgConf from "@tvg/conf";
import { useDispatch, useSelector } from "react-redux";
import {
  getHomepageConfigByPES,
  getHomepageConfigByStoryblok
} from "../utils/homepageConfig";
import { HomepageConfig, HomepageConfigType } from "../utils/types";
import { getHasRequest } from "../redux/selectors";
import { setHasRequest } from "../redux/actions";

export const useHomepageConfig = (
  homepageCachedConfig: HomepageConfig | null = null,
  enableStoryblokConfig: boolean,
  customOptions: Object = {}
) => {
  const dispatch = useDispatch();
  const hasRequest = useSelector(getHasRequest);
  const [homepageConfig, setHomepageConfig] = useState<HomepageConfig>(
    homepageCachedConfig || {
      order: {
        default: {
          header: [],
          body: [],
          unmapped: []
        }
      },
      currentConfig: HomepageConfigType.DEFAULT,
      ctaButtons: {}
    }
  );

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      (!hasRequest ||
        (!has(homepageCachedConfig, "order.default.body[0]") &&
          !has(homepageCachedConfig, "order.default.unmapped[0]")))
    ) {
      if (enableStoryblokConfig) {
        getHomepageConfigByStoryblok(
          tvgConf().config().storyblokVersion,
          customOptions,
          tvgConf().config().storyblokToken
        ).then((config) => {
          setHomepageConfig(config);
        });
      } else {
        getHomepageConfigByPES().then((order) => {
          setHomepageConfig({
            order: {
              default: {
                header: [],
                body: [],
                unmapped: order
              }
            },
            eventInfo: get(customOptions, "pesEventInfo.event"),
            currentConfig: HomepageConfigType.DEFAULT,
            ctaButtons: get(customOptions, "pesEventInfo.cta", {})
          });
        });
      }
      dispatch(setHasRequest());
    } else if (homepageCachedConfig) {
      setHomepageConfig(homepageCachedConfig);
    }
  }, []);

  return homepageConfig;
};
